import React, { Fragment, useContext, useEffect, useState } from 'react';
import './GuidancePageBody.scss';
import PageBodyWrapper from "root/PageBodyWrapper";
import GlobalContext from "root/Contexts/GlobalContext";

import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { getActiveGuidanceForSurveyType } from "root/DataFunctions/GuidanceFunctions";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import GuidanceNotePanel from "root/GuidanceNotePanel";


const GuidancePageBody = (props) =>
{

    useEffect(()=>{
        getData();
    },[])

    const [data, setData] = useState({isLoading: true, data: []});
    const [search, setSearch] = useState('');

    const sessionContext = useContext( GlobalContext ) ;

    const survey_type = sessionContext.getCurrentSurveyType() ;

    const getData = () => {

        getActiveGuidanceForSurveyType(survey_type, (response) =>
        {
            const responseData = getDataFromResponse(response);

            setData({isLoading: false, data: responseData});
        });
    };

    const guidancePage = () =>
    {
        const q = search.trim().toLowerCase();
        const rows = data.data.filter(row =>
            !q || `${row.title} ${row.hyperlink_text}`.toLowerCase().includes(q));

        return (
            <div className='guidance-grid'>
                {rows.length > 0
                    ? rows.map((row, key) =>
                        <GuidanceNotePanel key={key}
                                           title={row.title}
                                           description={row.hyperlink_text}
                                           url={row.url}/>)
                    : <div className='guidance-empty'>No guidance matches “{search}”.</div>}
            </div>
        )
    }

    const guidance = () =>
    {
        if ( data.isLoading === true )
        {
            return <SpinnerDiv/>
        }
        else
        {
            return guidancePage() ;
        }
    }

    return (
        <Fragment>
            <PageBodyWrapper title='Guidance Notes' backButton={false}>
                <div className='guidance-layout'>
                    <div className='guidance-head'>
                        <p>Links you may find useful when completing your audit.</p>
                        <label className='guidance-search'>
                            <i className='bi bi-search'></i>
                            <input type='search'
                                   placeholder='Search guidance'
                                   aria-label='Search guidance'
                                   value={search}
                                   onChange={(e) => setSearch(e.target.value)}/>
                        </label>
                    </div>
                    {guidance()}
                </div>
            </PageBodyWrapper>
        </Fragment>
    )
}

export default GuidancePageBody;
